var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "02 User 2",
    clipPath: "url(#clip0_633_71)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "02 User"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\xC3\xA9 426",
    d: "M1.02539 21.0035C0.822653 21.0035 0.62447 20.9434 0.455883 20.8307C0.287296 20.7181 0.155871 20.5581 0.0782138 20.3708C0.000556675 20.1835 -0.0198478 19.9774 0.0195787 19.7786C0.0590052 19.5797 0.156493 19.397 0.299725 19.2535L19.2499 0.299828C19.4427 0.107523 19.7039 -0.000327445 19.9762 7.46828e-07C20.2485 0.000328938 20.5095 0.108809 20.7018 0.301578C20.8941 0.494346 21.002 0.755611 21.0016 1.0279C21.0013 1.30019 20.8928 1.56119 20.7001 1.75349L1.75106 20.699C1.65623 20.7952 1.54327 20.8716 1.41871 20.9239C1.29415 20.9762 1.16047 21.0032 1.02539 21.0035Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\xC3\xA9 427",
    d: "M19.9746 21.0037C19.8399 21.004 19.7064 20.9777 19.5819 20.9262C19.4573 20.8748 19.3442 20.7992 19.249 20.7038L0.299966 1.75368C0.107197 1.56091 -0.00109863 1.29946 -0.00109863 1.02684C-0.00109863 0.754229 0.107197 0.49278 0.299966 0.300011C0.492734 0.107243 0.754184 -0.00105286 1.0268 -0.00105286C1.29941 -0.00105286 1.56086 0.107243 1.75363 0.300011L20.6991 19.2537C20.8424 19.3972 20.9399 19.5799 20.9793 19.7788C21.0187 19.9776 20.9983 20.1837 20.9206 20.371C20.843 20.5583 20.7116 20.7183 20.543 20.8309C20.3744 20.9435 20.1774 21.0037 19.9746 21.0037Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_633_71"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.011019f5991dfda1e1733a04a40155b9.svg";
export { ForwardRef as ReactComponent };